import { render } from "./PlanillaDet.vue?vue&type=template&id=3aee14b6&scoped=true"
import script from "./PlanillaDet.vue?vue&type=script&lang=js"
export * from "./PlanillaDet.vue?vue&type=script&lang=js"

import "./PlanillaDet.vue?vue&type=style&index=0&id=3aee14b6&scoped=true&lang=css"
import "./PlanillaDet.vue?vue&type=style&index=1&id=3aee14b6&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\allikamay\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3aee14b6"]])

export default __exports__